// ═══════════════════════════════════════════════════════
// ROUTER — barrel export (migrated to react-router-dom v6)
// ═══════════════════════════════════════════════════════
export { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

// ── Helpers: pageId ↔ path ───────────────────────────────
// Rota padrão: "/<pageId>" — ex: /dashboard, /carteira, /perfil
// Raiz "/" redireciona para /dashboard.
export function pathToPageId(pathname) {
  const seg = pathname.replace(/^\/+/, "").split("/")[0];
  return seg || "dashboard";
}

export function pageIdToPath(pageId) {
  return `/${pageId}`;
}
